<template lang="pug">
  .home

    include mixins.pug

    Navbar
    .section.list(v-if='!verDetalles')
      .subtitle Clientes
      .level.panel
        form(@submit.prevent='searchByCodigo').level-left
          .level-item
            input.input(placeholder='Cédula' v-model='search.cedula')
          .level-item
            input.input(placeholder='Nombres' v-model='search.nombres')
          .level-item
            input.input(placeholder='Apellidos' v-model='search.apellidos')
          .level-item
            button.button.is-primary(:class="{'is-loading': searching}") Buscar
      
      progress.progress.is-small.is-primary(v-if='searching' max='100') 50

      table.table.is-bordered.is-striped.is-fullwidth.is-hoverable
        thead
          tr
            th Código
            th Cédula
            th Nombres
            th Apellidos
            th Código Zona
            th Teléfono
            th Acciones
        tbody(v-for='cli in clientes')
          tr
            td {{ cli.codigo }}
            td {{ cli.usuario }}
            td {{ cli.nombres }}
            td {{ cli.apellidos }}
            td {{ cli.codzona }}
            td {{ cli.telefono }}
            td.has-text-centered
              button.button.is-primary(@click.prevent='verDatos(cli)') Datos

    .section.detail(v-else @keyup.esc='verDetalles = false')
        h1.title Detalles del Cliente
        form.form
          .columns
            +textField('Código', 'cliente.codigo', 'codigoInput')
            +textField('Zona', 'cliente.codzona')
          .columns
            +textField('Cédula', 'cliente.usuario')
            +textField('Nombres', 'cliente.nombres')
            +textField('Apellidos', 'cliente.apellidos')
          .columns
            +textField('Negocio', 'cliente.negocio')
            +textField('Dirección', 'cliente.direccion')
            +dateField('Fecha nac.', 'cliente.fecha_nac | dateFmt')
          .columns
            +textField('Teléfono', 'cliente.telefono')
            +textField('Celular', 'cliente.celular')
            +textField('Linea Cred.', 'cliente.linea_cred')
          .columns
            +textField('Distrito', 'cliente.distrito')
            +textField('Barrio', 'cliente.barrio')
            +textField('Departamento', 'cliente.departam')
          .columns
            +txtAreaField('Notas', 'cliente.notas')

        br/
        
        .title.is-4 Referencias
        table.table.is-bordered.is-striped.is-hoverable
          thead
            tr
              th Cédula
              th Nombre
              th Notas
              th Teléfono
          tbody(v-for='ref in referencias')
            tr
              td {{ ref.ci }}
              td {{ ref.nombre }}
              td {{ ref.notas }}
              td {{ ref.telefono }}

        .title.is-4 Historial
        table.table.is-bordered.is-striped.is-hoverable
          thead
            tr
              th Solicitud
              th Fecha Crédito
              th Monto Solicitado
              th Monto Credito
              th Saldo
              th Ultimo Pago
              th Ultimo Vencimiento
              th Dias de mora
              th Coutas atrasadas
              th Cobrador
          tbody(v-for='sol in solicitudes')
            tr
              td {{ sol.solicitud }}
              td {{ sol.fec_cred }}
              td {{ sol.monto_sol }}
              td {{ sol.monto_cred }}
              td {{ sol.saldo }}
              td {{ sol.ult_pago }}
              td {{ sol.ult_venc }}
              td {{ sol.dias_mora }}
              td {{ sol.atrasos }}
              td {{ sol.cobrador }}
          
        button.button.is-info(@click.prevent='verDetalles = false') Volver

</template>

<script>

import Navbar from '@/components/Navbar.vue'
import firebase from 'firebase/app';
import 'firebase/auth';
import 'firebase/firestore';

async function busqueda(search) {
  let cedula = search.cedula
  let nombres = search.nombres
  let apellidos = search.apellidos

  var query = firebase.firestore().collection('usuarios').limit(100)
  
  if(cedula) 
    query = query.where('usuario', '==', Number(cedula))

  // firebase no soporte rage search (<=, >=, etc.) con más de un campo.
  // Por lo tanto simulamos hacer eso desde el cliente.
  if(nombres && apellidos)
    query = query.where('nombres', '>=', nombres)
  else if(nombres) 
    query = query.where('nombres', '>=', nombres)
  else if(apellidos) 
    query = query.where('apellidos', '>=', apellidos)

  return query.get().then(snapshot => {
    let clientes = []
    snapshot.forEach(doc => clientes.push(doc.data()))
   
    // la explicación de porque hacemos esto esta arriba
    if(nombres && apellidos)
      clientes = clientes.filter(el => el.apellidos >= apellidos)

    return clientes
  })
}

export default {
  name: 'clientes',
  data () {
    return {
      clientes: [],
      solicitudes: [],
      referencias: [],
      cliente: {}, 
      search: {
        cedula: null,
        nombres: null,
        apellidos: null
      },
      searching: false,
      verDetalles: false
    }
  },
  filters: {
    dateFmt(date) {
      if (date)
        return date.split('T')[0]
      return date
    }
  },
  components: {
    Navbar
  },
  created: function() {
    this.searching = true
    firebase.auth().onAuthStateChanged(user => {
      busqueda(this.search).then(clientes => {
        this.clientes = clientes
        this.searching = false
      })
    })
  },
  methods: {
    searchByCodigo: function () {
      this.searching = true
      busqueda(this.search).then(clientes => {
        this.clientes = clientes
        this.searching = false
      })
    },
    verDatos: function (cliente) {
      this.cliente = cliente
      firebase.firestore().collection('solicitu').where('usuario', '==', cliente.usuario).get().then(snapshot => {
        this.solicitudes = []
        snapshot.forEach(doc => this.solicitudes.push(doc.data())) 
      })
      firebase.firestore().collection('referencias').where('usuario', '==', cliente.usuario).get().then(snapshot => {
        this.referencias = []
        snapshot.forEach(doc => this.referencias.push(doc.data())) 
      })
      this.verDetalles = true
      this.$nextTick(() => this.$refs.codigoInput.focus())
    }
  }
}
</script>
